export default {
  alchemyPopper: 1050, // what Alchemy uses as of 2021/03/02
  streamSlideout: 1051,
  streamSlideoutHeader: 2, // Here the zIndex value is reset as this is inside the container.
  notificationDisplay: 2000,
  trendsErrorOverlay: 11,
  trendsLoadingOverlay: 11,
};
